import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import ConferenceSelector from "../components/conferenceselector"

const GraphPage = () => (
  <>
    <Layout>
      <div style={{width:`95%`, margin:`1.5rem auto`}}>
        <SEO title="Conference Archives" />
        <ConferenceSelector />
        {` `}
      </div>
    </Layout>
  </>
)

export default GraphPage
